import DataSyncer from "./DataSyncer";
export default DataSyncer;
